import * as generalConstants from "../constants/generalConstant";

export const openSignUpModal = () => async (dispatch) => {
  dispatch({
    type: generalConstants.OPEN_SIGNUP_MODAL,
  });
};

export const closeSignUpModal = () => async (dispatch) => {
  dispatch({
    type: generalConstants.CLOSE_SIGNUP_MODAL,
  });
};

export const openPaymentIssueModal = (errMessage) => async (dispatch) => {
  dispatch({
    type: generalConstants.OPEN_PAYMENT_ISSUE_MODAL,
    payload: errMessage,
  });
};

export const closePaymentIssueModal = () => async (dispatch) => {
  dispatch({
    type: generalConstants.CLOSE_PAYMENT_ISSUE_MODAL,
  });
};
